import { render } from "./NewSiteForm.vue?vue&type=template&id=252c49f8"
import script from "./NewSiteForm.vue?vue&type=script&lang=js"
export * from "./NewSiteForm.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/Saad/Documents/GitHub/link-portal/link/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__